import React from 'react';
import { ALBA_PRODUCTS } from '../../utils/albaFlowRules';

const CATEGORY_LABELS = {
  magic: 'ALBA MAGIC',
  circle: 'ALBA CIRCLE',
  square: 'ALBA SQUARE',
  mini: 'ALBA MINI',
  accessori: 'ACCESSORI ALBA',
};

const AlbaProductSelector = ({ subCategory, onSelect }) => {
  const cat = ALBA_PRODUCTS[subCategory];
  if (!cat) return null;

  if (subCategory === 'accessori') {
    return (
      <div className="text-center">
        <h1 className="text-xl font-bold mb-4">ACCESSORI ALBA</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          {cat.items.map((item) => (
            <button
              key={item.code}
              onClick={() => onSelect(item)}
              className="p-4 border rounded-lg border-gray-300 hover:bg-red-100 hover:border-red-500 transition-colors duration-200"
            >
              <div className="flex flex-col items-center">
                <span className="font-mono text-sm font-bold text-gray-700">{item.code}</span>
                <span className="font-medium mt-2">{item.description}</span>
                <div className="flex flex-wrap gap-1 mt-2 justify-center">
                  {item.validFor.map(v => (
                    <span key={v} className="text-xs text-gray-500">
                      {v === 'circle' ? 'Circle' : 'Square'}
                    </span>
                  ))}
                </div>
                <span className="text-sm text-gray-500 mt-2">&euro; {item.price.toFixed(2)}/pz</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    );
  }

  const groups = [
    { key: 'standard', label: 'Standard', items: cat.standard || [] },
    { key: 'trend', label: 'Trend RAL', items: cat.trend || [] },
    { key: 'custom', label: 'RAL Personalizzato', items: cat.custom || [] },
  ].filter(g => g.items.length > 0);

  return (
    <div className="text-center">
      <h1 className="text-xl font-bold mb-4">{CATEGORY_LABELS[subCategory]}</h1>
      <p className="mb-4 text-gray-600">Seleziona il prodotto</p>

      {groups.map(group => (
        <div key={group.key} className="mb-6">
          <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">{group.label}</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {group.items.map((product) => (
              <button
                key={product.code}
                onClick={() => onSelect(product)}
                className="p-4 border rounded-lg border-gray-300 hover:bg-red-100 hover:border-red-500 transition-colors duration-200"
              >
                <div className="flex flex-col items-center">
                  <span className="font-mono text-sm font-bold text-gray-700">{product.code}</span>
                  <span className="font-medium mt-2">{product.finish}</span>
                  <span className="text-sm text-gray-500 mt-1">&euro; {product.price.toFixed(2)}/pz</span>
                  {product.minQty > 0 && (
                    <span className="text-xs text-red-500 mt-1">Min. {product.minQty} pz</span>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlbaProductSelector;
